import { apiFetch } from './api';
import { setToken, clearToken, getToken } from './token';
import { API_BASE_URL } from '@/env';

type SignInResponse = {
  token?: string;
  user?: unknown;
  redirect?: boolean;
};

export async function signIn(email: string, password: string): Promise<void> {
  // Direct fetch (not apiFetch) so we can read the set-auth-token response header.
  const res = await fetch(`${API_BASE_URL}/api/auth/sign-in/email`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    let msg = 'Sign-in failed';
    try {
      const body = (await res.json()) as { message?: string };
      if (body?.message) msg = body.message;
    } catch {
      // ignore
    }
    throw new Error(msg);
  }
  const headerToken = res.headers.get('set-auth-token');
  let token: string | null = headerToken;
  if (!token) {
    // Fallback — some better-auth configs return the token in the body
    try {
      const body = (await res.json()) as SignInResponse;
      token = body.token ?? null;
    } catch {
      // ignore
    }
  }
  if (!token) {
    throw new Error('Sign-in succeeded but no token was returned');
  }
  setToken(token);
}

export async function signOut(): Promise<void> {
  try {
    await apiFetch('/api/auth/sign-out', { method: 'POST' });
  } catch {
    // Swallow — always clear the token locally
  }
  clearToken();
}

export type MeUser = {
  id: string;
  email: string;
  displayName: string;
  role: 'user' | 'admin';
  avatarUrl: string | null;
};

export type MeResponse = {
  user: MeUser;
  activeHome: unknown;
  memberships: unknown[];
};

export async function getMe(): Promise<MeResponse> {
  return apiFetch<MeResponse>('/api/me');
}

export function hasToken(): boolean {
  return getToken() !== null;
}
